
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/check/migrate-from-cash-flow-updates",
      function () {
        return require("private-next-pages/docs/check/migrate-from-cash-flow-updates.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/check/migrate-from-cash-flow-updates"])
      });
    }
  